import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as TbIcons from 'react-icons/tb';
import * as AiIcons from 'react-icons/ai';
import FileService from "../services/file.service";
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";
import $ from "jquery"
const API_PATH = "cases";

function AddEditCase({ history, match }) {

    // file upload constants
    const [selectedFiles, setSelectedFiles] = useState(undefined);
    const [currentFile, setCurrentFile] = useState(undefined);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
    const [documents, setDocuments] = useState([]);
    const [fileInfos, setFileInfos] = useState([]);
    const FILES_URL = "https://db.irli.org:8080/api/files/";
    const [mod, setMod] = useState(false);
    const [admin, setAdmin] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState([]);
    const [courts, setCourts] = useState([]);

    function onSelect(selectedList, selectedItem) {
        setCourts(selectedList);
    }

    function onRemove(selectedList, removedItem) {
        setCourts(selectedList);
    }

    const selectFile = (event) => {
        setSelectedFiles(event.target.files);
    };

    const upload = () => {
        let currentFile = selectedFiles[0];
        setProgress(0);
        setCurrentFile(currentFile);

        FileService.upload(currentFile, (event) => {
            setProgress(Math.round((100 * event.loaded) / event.total));
        })
            .then((response) => {
                setMessage(response.data.message);
                documents.push(currentFile.name);
                setDocuments(documents);
                var files = [];
                for (var x in documents) {
                    var file = new Object();
                    file.name = documents[x];
                    file.url = FILES_URL + file.name;
                    files.push(file);
                }
                setFileInfos(files);
            })
            .catch(() => {
                setProgress(0);
                setMessage("Could not upload the file!");
                setCurrentFile(undefined);
            });
        setSelectedFiles(undefined);
    };

    const { id } = match.params;
    const isAddMode = !id;
    // form validation rules
    const validationSchema = Yup.object().shape({
        case_name: Yup.string()
            .required('Case Name is required'),
        case_id: Yup.string(),
        description: Yup.string(),
        staff_member: Yup.string(),
        next_steps: Yup.string(),
        lead_counsel: Yup.string(),
        status: Yup.string()
            .required('Status type is required'),
        deadline: Yup.string(),
        document_type: Yup.string() //double check that this is handled everywhere in api backend
    });

    // functions to build form returned by useForm() hook
    const { register, handleSubmit, reset, setValue, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {

        var appellate_courts = [];
        for (var i in courts) {
            var court = new Object();
            court.name = courts[i].name;
            court.abbreviation = courts[i].abbreviation;
            appellate_courts.push(court);
        }
        console.log(JSON.stringify(appellate_courts));
        data.courts = appellate_courts;
	  data.deadline = data.deadline ? data.deadline : null;
        data.documents = documents;
        console.log("onSubmit: " + data.documents);
        console.log(JSON.stringify(data));
        return isAddMode
            ? createCase(data)
            : updateCase(id, data);
    }

    function createCase(data) {
        return AxiosService.create(API_PATH, data)
            .then(() => {
                console.log(JSON.stringify(data));
                history.push('.');
            })
    }

    function deleteFile(name) {

        var filteredDocs = documents.filter(e => e !== name)
        setDocuments(filteredDocs);

        var files = [];
        for (var x in filteredDocs) {
            var file = new Object();
            file.name = filteredDocs[x];
            file.url = FILES_URL + file.name;
            files.push(file);
        }
        setFileInfos(files);
    }

    function updateCase(id, data) {
        return AxiosService.update(API_PATH, id, data)
            .then(() => {
                history.push('..');
            })
    }

    useEffect(() => {
        AxiosService.getAll("courts").then(x => {
            setOptions(x.data)
        }
        );
        const user = AuthService.getCurrentUser();
        var documents = [];
        if (user) {
            setMod(user.roles.includes("ROLE_MODERATOR"));
            setAdmin(user.roles.includes("ROLE_ADMIN"));
        }
        if (!isAddMode) {
            // get user and set form fields
            AxiosService.get(API_PATH, id).then(x => {
                var lawsuit = x.data;
                setSelectedValue(lawsuit.courts);
                console.log("lawsuit: " + JSON.stringify(lawsuit.data));
                const fields = ['case_name', 'case_id', 'description', 'staff_member', 'next_steps', 'document_type', 'lead_counsel', 'status', 'deadline', 'courts'];
                fields.forEach(field => setValue(field, lawsuit[field]));
                //fixes null for documents
                documents = lawsuit.documents == null ? [] : lawsuit.documents;
                setDocuments(documents);
                FileService.getFiles().then((response) => {
                    var files = [];
                    for (var x in documents) {
                        var doc = documents[x];
                        var file = new Object();
                        file.name = doc;
                        file.url = FILES_URL + doc;
                        files.push(file);
                    }
                    console.log("file infos: " + JSON.stringify(files));
                    setFileInfos(files); // previously response.data
                });
            })
        }

    }, []);

    $(document).ready(function () {
        $(document).on('focus', ':input', function () {
            $(this).attr('autocomplete', 'off');
        });
    });

    return (
        <div>

            <form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
                <h1>{isAddMode ? 'Add Case' : 'Edit Case'}</h1>

                <div style={{ width: 450 }} className="form-row">

                    <label>Case Name</label>
                    <input autoComplete="off" name="case_name" type="text" ref={register} className={`form-control ${errors.case_name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.case_name?.message}</div>
                </div>


                {/* <div className="form-row">
                    <div className="form-group col-5">
                        <label>Case Id</label>
                        <input autoComplete="off" name="case_id" type="text" ref={register} className={`form-control ${errors.case_id ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.case_id?.message}</div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Appellate Courts</label>
                        <Multiselect
                            options={options} // Options to display in the dropdown
                            selectedValues={selectedValue} // Preselected value to persist in dropdown
                            onSelect={onSelect} // Function will trigger on select event
                            onRemove={onRemove} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                            closeOnSelect={true}
                            avoidHighlightFirstOption="true"
                        />
                    </div>
                </div> */}

                <div className="form-row">
                    <label>Description</label>
                    <textarea autoComplete="off" name="description" rows={7} ref={register} className={`form-control ${errors.description ? 'is-invalid' : ''}`} />
                </div>

                <div style={{ width: 450 }} className="form-row">

                    <label>Attorney / Staff Member</label>
                    <input autoComplete="off" name="staff_member" type="text" ref={register} className={`form-control ${errors.staff_member ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.staff_member?.message}</div>
                </div>


                <div className="form-row">
                    <label>Status / Next Steps</label>
                    <textarea autoComplete="off" name="next_steps" rows={7} ref={register} className={`form-control ${errors.next_steps ? 'is-invalid' : ''}`} />
                </div>

                {/* documents file upload here */}
                <div className="form-group" style={{ marginTop: 25 }}>







                    {/* List all files */}


                    <div className="card">
                        <input type="file" onChange={selectFile} />
                        <br></br>
                        {message && <div className="alert alert-light" role="alert">
                            {message}
                        </div>}
                        <button
                            className="btn makeSmallbtn btn-success"
                            disabled={!selectedFiles}
                            onClick={upload}
                            style={{ marginBottom: 10 }}
                        >
                            Upload
                        </button>
                        {currentFile && (
                            <div className="progress">
                                <div
                                    className="progress-bar progress-bar-info progress-bar-striped"
                                    role="progressbar"
                                    aria-valuenow={progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    style={{ width: progress + "%" }}
                                >
                                    {progress}%
                                </div>
                            </div>
                        )}
                        <div className="card-header">Documents</div>

                        <ul className="list-group list-group-flush">
                            <label className="btn btn-default">


                            </label>

                            {fileInfos && fileInfos.map((file, index) => (
                                <li className="list-group-item" key={index}>
                                    <a href={file.url}><AiIcons.AiOutlineFilePdf size={24} /> {file.name} </a>
                                    <button type="button" onClick={() => deleteFile(file.name)} className="btn btn-sm btn-danger mr-3"> <TbIcons.TbTrash size={24} />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* radio buttons for Yes/No Lead Plaintiff Counsel? */}
                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Lead Plantiff Counsel?</label>
                        <select name="lead_counsel" ref={register} className={`form-control ${errors.lead_counsel ? 'is-invalid' : ''}`}>
                            <option value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                        <div className="invalid-feedback">{errors.lead_counsel?.message}</div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Status *</label>
                        <select name="status" ref={register} className={`form-control ${errors.status ? 'is-invalid' : ''}`}>
                            <option value=""></option>
                            <option value="Active">Active</option>
                            <option value="Archive">Archive</option>
                            <option value="Prospective">Prospective</option>
                        </select>
                        <div className="invalid-feedback">{errors.status?.message}</div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Document Type</label>
                        <input name="document_type" type="text" ref={register} className={`form-control ${errors.document_type ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.document_type?.message}</div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5" style={{ marginBottom: 25 }}>
                        <label>Deadline</label>
                        <input autoComplete="off" type="date" name="deadline" ref={register} {...register("deadline", {})} className={`form-control ${errors.deadline ? 'is-invalid' : ''}`} />
                    </div>
                </div>
                <div className="form-group">
                    {(mod || admin) && (
                        <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                            {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            Save
                        </button>
                    )}
                    <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
                </div>
            </form >
        </div>

    );
}

export { AddEditCase };